import { render } from "./notifications.html?vue&type=template&id=62bc7fe8&ts=true&external"
import script from "./notifications.ts?vue&type=script&lang=ts&external"
export * from "./notifications.ts?vue&type=script&lang=ts&external"

import "./notifications.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__